import { useState } from "react";
import PayrollCompanyLayout from "../../../components/layouts/PayrollCompanyLayout";
import { Helmet } from "react-helmet-async";
import CustomTab from "../../../components/custom_tab/CustomTab";
import { SavingsAndBackpayTabColumns } from "../../../components/custom_tab/tabColumns";
import { useSearchParams } from "react-router-dom";
import SavingsView from "./views/SavingsView";
import BackPayView from "./views/BackPayView";
import { PERMISSIONS, useValidateUserPermissions } from "../../../helpers/usePermissionManager";

const SavingsAndBackpay = () => {
	const hasPermission = useValidateUserPermissions(
		[PERMISSIONS.COMPANY_CONFIGS_WRITE, PERMISSIONS.COMPANY_CONFIGS_READ], 
		"OR"
	);
	const [searchParams] = useSearchParams();
	const [view, setView] = useState(
		searchParams.get("view") || "savings"
	);

	return (<>
		{hasPermission && (
			<PayrollCompanyLayout>
				<Helmet>
					<title>Savings & Back Pay | Company Flow</title>
				</Helmet>
				<h1 className="font-bold text-xl mb-8">Savings & Back Pay</h1>
				<CustomTab
					view={view}
					setView={setView}
					tabColumns={SavingsAndBackpayTabColumns}
				>
					{view === "savings" && <SavingsView />}
					{view === "backpay" && <BackPayView />}
				</CustomTab>
			</PayrollCompanyLayout>
		)}
	</>);
};

export default SavingsAndBackpay;
